import type { Menu } from '#/global'

const menus: Menu.recordRaw = {
  path: '/message/list',
  meta: {
    title: '留言管理',
    icon: 'i-ep:message',
  },
}

export default menus
